import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TokenManager } from '../utils/tokenManager';
// import { useAppContext } from '../providers/AppProvider';
// import { requestSiteToken } from '../hooks/CallApi';

// 라우트 이동 시 추가 토큰 상태 체크 훅 (ProtectedRoute와 함께 사용)
export const useRouteTokenGuard = () => {
    const location = useLocation();

    useEffect(() => {
        const checkAdditionalRouteAccess = () => {
            const userRole = TokenManager.getUserRole();
            const currentPath = location.pathname;

            // SA 유저 특별 처리 - siteToken 관련 알림만 처리
            if (userRole === 'SA' && (currentPath.includes('/safedb/SA/') || currentPath.startsWith('/safedb/SA/'))) {
                const siteToken = sessionStorage.getItem('siteToken');

                if (siteToken) {
                    console.log(`SA 경로 접근 시 siteToken 제거: ${currentPath}`);
                    toast.warning('WARNING! 관리자 권한으로 이동합니다. 고객사 모드 디스커넥트... 올 시스템 노멀!');
                }
            }
        };

        // 페이지 이동할 때마다 체크 (인증은 ProtectedRoute에서 처리됨)
        checkAdditionalRouteAccess();

    }, [location.pathname]); // 경로가 변경될 때마다 실행

    return null; // UI를 렌더링하지 않는 훅
};
